module.exports = __webpack_public_path__ + "img/barre-8.4ff9deb4.png";